import LegalPage, { LSection } from "../../components/legal/LegalPage";

const COOKIES = [
  {
    name: "access_token",
    provider: "Asset Passport",
    purpose: "Autenticación y sesión del usuario (cookie técnica HttpOnly)",
    type: "Necesaria",
    duration: "14 días",
  },
  {
    name: "mfa_pending",
    provider: "Asset Passport",
    purpose: "Reto temporal de verificación en dos pasos (2FA), solo si la cuenta lo tiene activado",
    type: "Necesaria",
    duration: "5 minutos",
  },
  {
    name: "__cf_bm",
    provider: "Cloudflare",
    purpose: "Protección de red y gestión de bots",
    type: "Necesaria (seguridad)",
    duration: "30 minutos",
  },
  {
    name: "cf_clearance",
    provider: "Cloudflare",
    purpose: "Verificación de seguridad anti-bot de la red de entrega",
    type: "Necesaria (seguridad)",
    duration: "Según configuración del proveedor",
  },
];

export default function Cookies() {
  return (
    <LegalPage
      title="Política de cookies"
      subtitle="Estado actual del uso de cookies y tecnologías similares en Asset Passport."
      testid="cookies-page"
    >
      <LSection n="1" title="Qué son las cookies">
        <p>
          Las cookies y tecnologías de almacenamiento similares son pequeños elementos que un sitio
          web o aplicación utiliza en el navegador para funcionar correctamente, mantener sesiones o
          proteger el servicio.
        </p>
      </LSection>

      <LSection n="2" title="Situación actual">
        <p>
          Asset Passport utiliza actualmente únicamente cookies y tecnologías necesarias para la
          autenticación, la sesión y la seguridad, la protección de la red y la entrega del
          servicio.
        </p>
        <p>
          Actualmente Asset Passport no utiliza cookies de analítica o publicidad propias de
          PostHog, ya que dicha herramienta se encuentra desactivada.
        </p>
      </LSection>

      <LSection n="3" title="Cookies utilizadas actualmente">
        <div className="overflow-x-auto -mx-2 px-2">
          <table className="w-full text-sm border border-zinc-200 rounded-xl overflow-hidden" data-testid="cookies-table">
            <thead>
              <tr className="bg-zinc-50 text-left text-zinc-900">
                <th className="px-4 py-3 font-medium">Cookie</th>
                <th className="px-4 py-3 font-medium">Proveedor</th>
                <th className="px-4 py-3 font-medium">Finalidad</th>
                <th className="px-4 py-3 font-medium">Tipo</th>
                <th className="px-4 py-3 font-medium">Duración</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100">
              {COOKIES.map((c) => (
                <tr key={c.name}>
                  <td className="px-4 py-3 font-mono text-xs text-zinc-800">{c.name}</td>
                  <td className="px-4 py-3">{c.provider}</td>
                  <td className="px-4 py-3">{c.purpose}</td>
                  <td className="px-4 py-3">{c.type}</td>
                  <td className="px-4 py-3">{c.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </LSection>

      <LSection n="4" title="Consentimiento">
        <p>
          Al utilizarse únicamente cookies técnicas necesarias, Asset Passport no muestra
          actualmente un banner de consentimiento de cookies. La arquitectura legal está preparada
          para incorporar un gestor de consentimiento si en el futuro se habilitan cookies no
          esenciales de analítica o publicidad.
        </p>
        <p>
          Si el uso de cookies cambia, esta política y, cuando sea exigible, el mecanismo de
          consentimiento se actualizarán conforme a la normativa aplicable.
        </p>
      </LSection>
    </LegalPage>
  );
}
